import React from 'react';
import { useP2GAppContext } from '@parcel2go/peacock-legacy-app/dist/contextProvider';
import { Layout } from '@parcel2go/peacock-legacy-layout/dist/layout';
import { P2GMyAccountLayout } from '@parcel2go/legacy-my-account-core/dist/layout';
import { IP2GP2GMyAccountSearch } from '@parcel2go/legacy-my-account-core/dist/search';
import AppMain from './AppMain';
import { P2GProgress } from '@parcel2go/peacock-legacy-core/dist/progress';
import SettingsWrapper from './SettingsWrapper';

export interface SearchConfigType extends IP2GP2GMyAccountSearch {
  searchEnabled: boolean;
}

interface props {
  isAppSignin: boolean;
  profileId: string;
}

const AppLayout: React.FC<props> = (props) => {
  const { auth, layout } = useP2GAppContext();

  const searchConfig: SearchConfigType = {
    searchEnabled: true,
    searchHeader: 'Previous Order Search',
  };

  return (
    <Layout
      {...layout}
      minHeight="750px"
      authenticated={props.isAppSignin || auth.authenticated}
      hideFooter={props.isAppSignin}
      hideHeader={props.isAppSignin}
      maxWidth={false}>
      <P2GMyAccountLayout title="Integrations" search={searchConfig}>
        {auth.authenticated ? (
          <SettingsWrapper profileId={props.profileId}>
            <AppMain />
          </SettingsWrapper>
        ) : (
          <P2GProgress />
        )}
      </P2GMyAccountLayout>
    </Layout>
  );
};

export default AppLayout;
